const env = process.env;

const clean = (value, fallback) => {
  const normalized = value?.trim();
  return normalized || fallback;
};

const casinoName = clean(env.REACT_APP_CASINO_NAME, "Casino");
const casinoType = clean(env.REACT_APP_CASINO_TYPE, "Template");
const shortName = clean(
  env.REACT_APP_CASINO_SHORT_NAME,
  casinoName
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 3)
    .toUpperCase() || "CS"
);

const fullName = clean(env.REACT_APP_CASINO_FULL_NAME, `${casinoName} ${casinoType}`);
const originalsLabel = clean(
  env.REACT_APP_CASINO_ORIGINALS_LABEL,
  `${shortName} Originals`
);
const botsLabel = clean(env.REACT_APP_CASINO_BOTS_LABEL, `${shortName} Bots`);
const botSingularLabel = clean(
  env.REACT_APP_CASINO_BOT_LABEL,
  botsLabel.endsWith("s") ? botsLabel.slice(0, -1) : botsLabel
);
const coinName = clean(env.REACT_APP_COIN_NAME, "Coins");
const coinTicker = clean(env.REACT_APP_COIN_TICKER, `${shortName}G`);

const possessive = (value) => (value.endsWith("s") ? `${value}'` : `${value}'s`);

export const brand = {
  casinoName,
  casinoType,
  fullName,
  shortName,
  originalsLabel,
  botsLabel,
  botSingularLabel,
  sportsBotsLabel: clean(
    env.REACT_APP_CASINO_SPORTS_BOTS_LABEL,
    `Sports ${botsLabel}`
  ),
  lotteryLabel: clean(env.REACT_APP_CASINO_LOTTERY_LABEL, `${shortName} Lottery`),
  playSectionLabel: clean(
    env.REACT_APP_CASINO_PLAY_SECTION_LABEL,
    `PLAY ${shortName} GAMES`
  ),
  coinName,
  coinTicker,
  couponCode: clean(env.REACT_APP_CASINO_COUPON_CODE, casinoName),
  logoUrl: clean(env.REACT_APP_CASINO_LOGO_URL, ""),
  iconUrl: clean(env.REACT_APP_CASINO_ICON_URL, ""),
  websiteUrl: clean(env.REACT_APP_CASINO_WEBSITE_URL, "/"),
  possessiveName: possessive(casinoName),
};

export default brand;
